/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  Input,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TabsModule } from "primeng/tabs";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ChipModule } from "primeng/chip";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MenuModule } from "primeng/menu";
import { MenuItem, MessageService } from "primeng/api";
import { SkeletonModule } from "primeng/skeleton";
import { TagModule } from "primeng/tag";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";
import { ToastModule } from "primeng/toast";

import { NgxJsonViewerModule } from "ngx-json-viewer";
import {
  QPilotService,
  QPilotAccessToken,
  QPilotUser,
} from "../../../../core/services/qpilot.service";
import { SessionService } from "../../../../core/services/session.service";
import { TimezoneHelper } from "../../../../core/utils/timezone.helper";
import { ProcessingCycle } from "../../interfaces/processing-cycle.interface";
import { ScheduledOrderListItem } from "../../interfaces/scheduled-orders-list-item.interface";
import { Site } from "../../../../core/models/site.interface";

// Static imports for dialogs - required for embedded mode where dynamic imports fail
// due to chunk loading from wrong origin
import { ProcessingCycleLogsDialogComponent } from "../processing-cycle-logs-dialog/processing-cycle-logs-dialog.component";
import { ProcessingCycleEditDialogComponent } from "../processing-cycle-edit-dialog/processing-cycle-edit-dialog.component";
import { ProcessingCycleVoidDialogComponent } from "../processing-cycle-void-dialog/processing-cycle-void-dialog.component";
import { ProcessingCycleCompleteDialogComponent } from "../processing-cycle-complete-dialog/processing-cycle-complete-dialog.component";

/**
 * Dashboard Processing Cycle View Component
 * Displays detailed information about a processing cycle with compact, modern design
 * Matches old QMC DashboardProcessingCycleViewComponent functionality
 *
 * Supports dual mode architecture:
 * - Standard mode: Uses Angular Router and SessionService
 * - Embedded mode: Uses input properties and emits custom events for navigation
 */
@Component({
  selector: "app-dashboard-processing-cycle-view",
  standalone: true,
  imports: [
    CommonModule,
    TabsModule,
    ButtonModule,
    CardModule,
    ChipModule,
    MenuModule,
    SkeletonModule,
    TagModule,
    TooltipModule,
    AccordionModule,
    NgxJsonViewerModule,
    ToastModule,
  ],
  providers: [DialogService],
  // Note: MessageService is NOT provided locally - we use the root instance
  // This ensures both component toast calls AND API interceptor error toasts
  // go to the same MessageService that the <p-toast> listens to
  templateUrl: "./dashboard-processing-cycle-view.component.html",
  styleUrl: "./dashboard-processing-cycle-view.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardProcessingCycleViewComponent
  implements OnInit, OnDestroy
{
  // Dual mode inputs for embedded mode
  @Input() inputSiteId?: number;
  @Input() inputScheduledOrderId?: number;
  @Input() inputProcessingCycleId?: number;
  @Input() inputToken?: QPilotAccessToken;
  @Input() embeddedMode: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() readOnlyMode: boolean = false;

  processingCycle: ProcessingCycle | null = null;
  scheduledOrder: ScheduledOrderListItem | null = null;
  site: Site | null = null;
  isLoading = false;
  siteId: number = 0;
  scheduledOrderId: number = 0;
  processingCycleId: number = 0;
  isStatusCollapsed = false;

  // Menu items for actions dropdown
  menuItems: MenuItem[] = [];

  // Dialog refs for cleanup
  private dialogRefs: DynamicDialogRef[] = [];

  // Pre-parsed JSON objects to avoid parsing in template (performance optimization)
  parsedPaymentGatewayResponse: any = {};
  parsedClientOrderCreationRequest: any = {};
  parsedClientOrderCreationResponse: any = {};
  parsedClientOrderUpdateRequest: any = {};
  parsedClientOrderUpdateResponse: any = {};

  constructor(
    private readonly elementRef: ElementRef,
    private qpilotService: QPilotService,
    private sessionService: SessionService,
    private timezoneHelper: TimezoneHelper,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const element = this.elementRef.nativeElement as HTMLElement;

    // Check if embedded mode is set via input or attribute
    const embeddedModeAttr =
      element.getAttribute("embedded-mode") ??
      element.getAttribute("embeddedMode");
    if (embeddedModeAttr === "true" || embeddedModeAttr === "") {
      this.embeddedMode = true;
    }

    if (this.embeddedMode) {
      // Get IDs from input/attributes
      const siteIdString =
        this.inputSiteId?.toString() ??
        element.getAttribute("input-site-id") ??
        element.getAttribute("inputSiteId");

      const scheduledOrderIdString =
        this.inputScheduledOrderId?.toString() ??
        element.getAttribute("input-scheduled-order-id") ??
        element.getAttribute("inputScheduledOrderId");

      const processingCycleIdString =
        this.inputProcessingCycleId?.toString() ??
        element.getAttribute("input-processing-cycle-id") ??
        element.getAttribute("inputProcessingCycleId");

      if (siteIdString) {
        this.siteId = parseInt(siteIdString, 10);
      }

      if (scheduledOrderIdString) {
        this.scheduledOrderId = parseInt(scheduledOrderIdString, 10);
      }

      if (processingCycleIdString) {
        this.processingCycleId = parseInt(processingCycleIdString, 10);
      }

      // Get token from attribute
      const tokenString =
        element.getAttribute("input-token") ??
        element.getAttribute("inputToken");

      // Create inputToken from attribute if:
      // 1. We have a token string from attribute
      // 2. AND inputToken is either missing, not an object, or doesn't have valid TokenBearerAuth
      // Note: Angular Elements may bind the attribute as a raw string, so we check for proper structure
      if (
        tokenString &&
        (!this.inputToken ||
          typeof this.inputToken !== "object" ||
          !this.inputToken.TokenBearerAuth)
      ) {
        this.inputToken = {
          TokenBearerAuth: tokenString,
          TokenAuth: "",
          Id: 0,
          UserId: 0,
          CreatedUtc: new Date(),
          UpdatedUtc: new Date(),
          ExpiresUtc: new Date(),
          User: {} as QPilotUser,
          FirstLogin: 0,
        };
      }

      this.initializeEmbeddedMode();
    } else {
      this.initializeStandardMode();
    }
  }

  ngOnDestroy(): void {
    // Close any open dialogs
    this.dialogRefs.forEach((ref) => ref.close());
  }

  /**
   * Initialize component in embedded mode
   */
  private initializeEmbeddedMode(): void {
    if (!this.inputToken || !this.siteId || !this.processingCycleId) {
      console.error("Missing required inputs for embedded mode");
      return;
    }

    this.isLoading = true;

    // Load site data with token
    this.qpilotService.getSite(this.siteId, this.inputToken).subscribe({
      next: (site) => {
        this.site = site as any;
        this.cdr.markForCheck();
        this.loadProcessingCycleWithToken(this.inputToken!);
        this.loadScheduledOrderWithToken(this.inputToken!);
      },
      error: (error) => {
        console.error("Failed to load site:", error);
        this.isLoading = false;
        this.cdr.markForCheck();
        this.showError("Failed to load site information");
      },
    });
  }

  /**
   * Initialize component in standard mode
   */
  private initializeStandardMode(): void {
    this.route.parent?.params.subscribe((parentParams) => {
      this.siteId = +parentParams["siteId"];

      this.route.params.subscribe((params) => {
        this.scheduledOrderId = +params["id"];
        this.processingCycleId = +params["processingCycleId"];

        const accessToken = this.getAccessToken();
        if (!accessToken) {
          return;
        }

        this.isLoading = true;

        // Load site data first
        this.qpilotService.getSite(this.siteId, accessToken).subscribe({
          next: (site) => {
            this.site = site as any;
            this.cdr.markForCheck();
            this.loadProcessingCycle();
            this.loadScheduledOrder();
          },
          error: (error) => {
            console.error("Failed to load site:", error);
            this.isLoading = false;
            this.cdr.markForCheck();
            this.showError("Failed to load site information");
          },
        });
      });
    });
  }

  /**
   * Helper method to get access token based on mode
   */
  private getAccessToken(): QPilotAccessToken | undefined {
    if (this.embeddedMode && this.inputToken) {
      return this.inputToken;
    }
    // Use null coalescing for type safety
    return this.sessionService.accessToken ?? undefined;
  }

  /**
   * Load processing cycle details (standard mode)
   */
  private loadProcessingCycle(): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.qpilotService
      .getProcessingCycle(accessToken, this.siteId, this.processingCycleId)
      .subscribe({
        next: (cycle) => {
          this.processingCycle = cycle;
          this.parseAndSetCycleData(cycle);
          this.buildMenuItems();
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Failed to load processing cycle:", error);
          this.isLoading = false;
          this.cdr.markForCheck();
          this.showError("Failed to load processing cycle");
        },
      });
  }

  /**
   * Load processing cycle with explicit token (embedded mode)
   */
  private loadProcessingCycleWithToken(token: QPilotAccessToken): void {
    this.qpilotService
      .getProcessingCycle(token, this.siteId, this.processingCycleId)
      .subscribe({
        next: (cycle) => {
          this.processingCycle = cycle;
          this.parseAndSetCycleData(cycle);
          this.buildMenuItems();
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Failed to load processing cycle:", error);
          this.isLoading = false;
          this.cdr.markForCheck();
          this.showError("Failed to load processing cycle");
        },
      });
  }

  /**
   * Parse and set processing cycle JSON data
   */
  private parseAndSetCycleData(cycle: ProcessingCycle): void {
    // Pre-parse JSON objects to avoid parsing in template (performance optimization)
    this.parsedPaymentGatewayResponse = this.parseJson(
      cycle.PaymentGatewayResponse,
    );
    this.parsedClientOrderCreationRequest = this.parseJson(
      cycle.ClientOrderCreationRequestJson,
    );
    this.parsedClientOrderCreationResponse = this.parseJson(
      cycle.ClientOrderCreationResponseJson,
    );
    this.parsedClientOrderUpdateRequest = this.parseJson(
      cycle.ClientOrderUpdateRequestJson,
    );
    this.parsedClientOrderUpdateResponse = this.parseJson(
      cycle.ClientOrderUpdateResponseJson,
    );
  }

  /**
   * Load scheduled order details (standard mode)
   */
  private loadScheduledOrder(): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.qpilotService
      .getScheduledOrder(this.scheduledOrderId, accessToken)
      .subscribe({
        next: (order) => {
          this.scheduledOrder = order;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Failed to load scheduled order:", error);
        },
      });
  }

  /**
   * Load scheduled order with explicit token (embedded mode)
   */
  private loadScheduledOrderWithToken(token: QPilotAccessToken): void {
    this.qpilotService
      .getScheduledOrder(this.scheduledOrderId, token)
      .subscribe({
        next: (order) => {
          this.scheduledOrder = order;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Failed to load scheduled order:", error);
        },
      });
  }

  /**
   * Build menu items for actions dropdown
   */
  private buildMenuItems(): void {
    this.menuItems = [
      {
        label: "View Processing Logs",
        icon: "pi pi-list",
        command: () => this.viewLogs(),
      },
    ];

    if (
      this.processingCycle?.CanBeEdited &&
      this.processingCycle.Status !== "Processing"
    ) {
      this.menuItems.push({
        label: "Edit Cycle",
        icon: "pi pi-pencil",
        command: () => this.openEditDialog(),
      });
    }

    if (
      this.processingCycle?.CanBeCompleted &&
      this.processingCycle.Status !== "Processing"
    ) {
      this.menuItems.push({
        label: "Complete Cycle",
        icon: "pi pi-check",
        command: () => this.openCompleteDialog(),
      });
    }

    if (
      this.processingCycle?.CanBeVoid &&
      this.processingCycle.Status !== "Processing"
    ) {
      this.menuItems.push({
        label: "Void Cycle",
        icon: "pi pi-undo",
        command: () => this.openVoidDialog(),
      });
    }
  }

  /**
   * View processing logs
   */
  viewLogs(): void {
    if (!this.processingCycle) return;

    // Get access token based on mode
    const accessToken = this.getAccessToken();

    // Use static import to avoid chunk loading issues in embedded mode
    const ref = this.dialogService.open(ProcessingCycleLogsDialogComponent, {
      header: `Processing Cycle ${this.processingCycle.ProcessingId || this.processingCycle.Id} Logs`,
      width: "90vw",
      height: "80vh",
      closable: true,
      closeOnEscape: true,
      data: {
        scheduledOrderId: this.processingCycle.ScheduledOrderId,
        siteId: this.siteId,
        processingCycleId: this.processingCycle.Id,
        processingCycle: this.processingCycle,
        accessToken: accessToken, // Pass access token for embedded mode
      },
    });
    this.dialogRefs.push(ref);
  }

  /**
   * Open complete cycle dialog
   */
  openCompleteDialog(): void {
    if (!this.processingCycle || !this.scheduledOrder || !this.site) return;

    // Get access token based on mode
    const accessToken = this.getAccessToken();

    // Use static import to avoid chunk loading issues in embedded mode
    const ref = this.dialogService.open(
      ProcessingCycleCompleteDialogComponent,
      {
        header: "Complete Processing Cycle",
        width: "500px",
        data: {
          site: this.site,
          scheduledOrder: this.scheduledOrder,
          chargedTotal: this.processingCycle.ChargedTotal,
          inputToken: accessToken, // Pass token for embedded mode
        },
      },
    );

    ref.onClose.subscribe((result) => {
      if (result) {
        this.processingCycle!.ChargedTotal = result.ChargedTotal;
        this.processingCycle!.PaymentGatewayTransactionId =
          result.PaymentGatewayTransactionId;
        this.processingCycle!.Status = "Processing";
        this.showSuccess("Processing cycle completed successfully");
      }
    });

    this.dialogRefs.push(ref);
  }

  /**
   * Open void cycle dialog
   */
  openVoidDialog(): void {
    if (!this.processingCycle || !this.scheduledOrder || !this.site) return;

    // Get access token based on mode
    const accessToken = this.getAccessToken();

    // Use static import to avoid chunk loading issues in embedded mode
    const ref = this.dialogService.open(ProcessingCycleVoidDialogComponent, {
      header: "Void Processing Cycle",
      width: "700px",
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      styleClass: "processing-cycle-void-dialog",
      data: {
        site: this.site,
        scheduledOrder: this.scheduledOrder,
        nextOccurrenceChanged:
          this.processingCycle.ScheduledOrderNextOccurrenceChanged,
        notes: this.processingCycle.Notes,
        inputToken: accessToken, // Pass token for embedded mode
      },
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        this.processingCycle!.Notes = result.Notes;
        this.showSuccess("Processing cycle voided successfully");
        this.goBack();
      }
    });

    this.dialogRefs.push(ref);
  }

  /**
   * Open edit cycle dialog
   */
  openEditDialog(): void {
    if (!this.processingCycle) return;

    // Get access token based on mode
    const accessToken = this.getAccessToken();

    // Use static import to avoid chunk loading issues in embedded mode
    const ref = this.dialogService.open(ProcessingCycleEditDialogComponent, {
      header: "Edit Processing Cycle",
      width: "500px",
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      styleClass: "processing-cycle-edit-dialog",
      data: {
        siteId: this.siteId,
        processingCycleId: this.processingCycle.Id,
        chargedTotal: this.processingCycle.ChargedTotal,
        notes: this.processingCycle.Notes,
        inputToken: accessToken, // Pass token for embedded mode
      },
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        this.showSuccess("Processing cycle updated successfully");
        this.loadProcessingCycle();
      }
    });

    this.dialogRefs.push(ref);
  }

  /**
   * Go back to scheduled order edit page
   * CRITICAL FIX: Supports dual mode navigation
   * - Standard mode: Uses Angular Router
   * - Embedded mode: Emits custom event for parent to handle
   */
  goBack(): void {
    if (this.embeddedMode) {
      // Emit custom event for parent application to handle navigation
      console.log("Processing Cycle - Emitting qmc-navigate-back event");
      const event = new CustomEvent("qmc-navigate-back", {
        detail: {
          component: "processing-cycle-view",
          targetComponent: "scheduled-order-edit",
          siteId: this.siteId,
          scheduledOrderId: this.scheduledOrderId,
          processingCycleId: this.processingCycleId,
        },
        bubbles: true,
        composed: true, // Crosses shadow DOM boundary
      });
      this.elementRef.nativeElement.dispatchEvent(event);
      console.log("Processing Cycle - Event dispatched");
    } else {
      // Standard navigation using Angular Router
      void this.router.navigate(
        [
          "/widgets",
          "dashboard",
          this.siteId,
          "scheduled-orders",
          this.scheduledOrderId,
          "edit",
        ],
        { relativeTo: null },
      );
    }
  }

  /**
   * Toggle status section collapse state
   */
  toggleStatusCollapse(): void {
    this.isStatusCollapsed = !this.isStatusCollapsed;
  }

  /**
   * Get status severity for tag
   */
  getStatusSeverity(status: string): "success" | "info" | "warning" | "danger" {
    switch (status?.toLowerCase()) {
      case "success":
        return "success";
      case "failed":
      case "void":
        return "danger";
      case "processing":
        return "info";
      case "queued":
        return "warning";
      default:
        return "info";
    }
  }

  /**
   * Format date with timezone
   */
  formatDate(date: Date | string | null | undefined): string {
    if (!date) return "-";
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return this.timezoneHelper.formatDateWithTimezone(
      dateObj,
      this.site?.UtcOffset ?? 0,
    );
  }

  /**
   * Format currency
   */
  formatCurrency(value: number | null | undefined): string {
    if (value == null) return "TBD";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(value);
  }

  /**
   * Get error documentation URL
   */
  getErrorDocUrl(errorCode: number | null | undefined): string {
    if (!errorCode) return "#";
    return `https://docs.qpilot.cloud/error-codes/${errorCode}`;
  }

  /**
   * Copy processing cycle ID to clipboard
   */
  copyProcessingId(): void {
    if (!this.processingCycle) return;
    const id = String(
      this.processingCycle.ProcessingId || this.processingCycle.Id,
    );

    navigator.clipboard.writeText(id).then(
      () => {
        this.showSuccess("Processing ID copied to clipboard");
      },
      (err) => {
        console.error("Failed to copy:", err);
        this.showError("Failed to copy ID");
      },
    );
  }

  /**
   * Copy JSON to clipboard
   */
  copyToClipboard(json: string | null | undefined): void {
    if (!json) return;

    navigator.clipboard.writeText(json).then(
      () => {
        this.showSuccess("Copied to clipboard");
      },
      (err) => {
        console.error("Failed to copy:", err);
        this.showError("Failed to copy to clipboard");
      },
    );
  }

  /**
   * Download JSON file
   */
  downloadJson(json: string | null | undefined, filename: string): void {
    if (!json) return;

    const blob = new Blob([json], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Parse JSON string to object for ngx-json-viewer
   * Handles double-encoded JSON (e.g., response objects with Content field)
   */
  parseJson(jsonString: string | null | undefined): any {
    if (!jsonString) return {};

    try {
      const parsed = JSON.parse(jsonString);

      // Check if this is a response object with HttpStatusCode and Content
      if (
        parsed &&
        typeof parsed === "object" &&
        "Content" in parsed &&
        typeof parsed.Content === "string"
      ) {
        try {
          // Parse the nested Content field
          parsed.Content = JSON.parse(parsed.Content);
        } catch {
          // If Content can't be parsed, leave it as is
        }
      }

      return parsed;
    } catch (error) {
      console.error("Failed to parse JSON:", error);
      return { _error: "Invalid JSON", _raw: jsonString };
    }
  }

  /**
   * Show success message
   */
  private showSuccess(message: string): void {
    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: message,
      life: 3000,
    });
  }

  /**
   * Show error message
   */
  private showError(message: string): void {
    this.messageService.add({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
    });
  }
}
